import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { WhatsappLogo, Gift, Copy, ArrowsClockwise } from "@phosphor-icons/react";

const buildMessage = (link) =>
  `🎵💛 Tengo que contarte esto…\n\nConvertí una historia real en una CANCIÓN de verdad — con voz, música y todo. La escuché y se me hizo un nudo en la garganta 🥹\n\nTú también puedes regalarle una canción a alguien que amas: a tu mamá, a tu pareja, a un amigo… con SU propia historia.\n\nEscúchala aquí y crea la tuya:\n${link}`;

export const ReferralCard = () => {
  const [data, setData] = useState(null);

  const load = () => api.get("/referrals/me").then(r => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!data) return null;

  const link = `${window.location.origin}/?ref=${data.code}`;
  const pct = Math.min(100, Math.round((data.visits / data.goal) * 100));
  const earned = Boolean(data.pin);

  const share = () => {
    window.open(`https://wa.me/?text=${encodeURIComponent(buildMessage(link))}`, "_blank");
  };

  const copyPin = async () => {
    try { await navigator.clipboard.writeText(data.pin); toast.success("PIN copiado"); }
    catch { toast.error("No se pudo copiar"); }
  };

  return (
    <div className="mt-6 rounded-2xl border border-[#B4F34A]/30 bg-gradient-to-br from-[#B4F34A]/10 to-transparent p-5" data-testid="referral-card">
      <div className="flex items-center gap-2 mb-1">
        <Gift size={20} weight="fill" className="text-[#B4F34A]" />
        <p className="font-display font-bold text-lg">Gana una canción GRATIS 🎁</p>
      </div>

      {earned ? (
        <div className="text-center py-2" data-testid="referral-earned">
          <p className="text-sm text-white/70 mb-3">
            ¡Lo lograste! 🔥 {data.goal} personas abrieron tu enlace. Este es tu PIN para
            <span className="text-[#B4F34A] font-semibold"> 1 canción gratis</span>:
          </p>
          <p className="font-display font-black text-4xl tracking-[0.25em] text-[#B4F34A] mb-3" data-testid="referral-pin">{data.pin}</p>
          <p className="text-xs text-white/50 mb-3">
            Úsalo en <span className="text-white">Pagos → &ldquo;¿Tienes PIN de acceso?&rdquo;</span> cuando quieras crear tu próxima canción.
          </p>
          <button onClick={copyPin} className="px-5 py-2.5 rounded-full bg-white/10 hover:bg-white/20 text-sm font-semibold inline-flex items-center gap-2" data-testid="referral-copy-pin">
            <Copy size={14} /> Copiar PIN
          </button>
        </div>
      ) : (
        <>
          <p className="text-sm text-white/70 mb-4">
            Comparte tu enlace por WhatsApp con tus amigos y familia. Cuando{" "}
            <span className="text-[#B4F34A] font-semibold">{data.goal} personas lo abran</span>,
            te regalamos un PIN para crear <span className="text-white font-semibold">1 canción totalmente gratis</span>.
          </p>

          <div className="flex items-center justify-between text-xs text-white/60 mb-1.5">
            <span>Progreso</span>
            <span className="font-mono" data-testid="referral-progress">{data.visits} / {data.goal} personas</span>
          </div>
          <div className="h-3 rounded-full bg-white/10 overflow-hidden mb-4">
            <div className="h-full rounded-full bg-[#B4F34A] transition-all duration-700" style={{ width: `${pct}%` }}></div>
          </div>

          <button
            onClick={share}
            className="w-full py-4 rounded-full bg-[#25D366] hover:bg-[#1FB858] text-black font-semibold flex items-center justify-center gap-2 transition-all active:scale-95"
            data-testid="referral-share-btn"
          >
            <WhatsappLogo weight="fill" size={20} /> Compartir con mis amigos
          </button>
          <button
            onClick={load}
            className="w-full mt-2 py-2 rounded-full text-xs text-white/40 hover:text-white/70 inline-flex items-center justify-center gap-1.5"
            data-testid="referral-refresh"
          >
            <ArrowsClockwise size={12} /> Actualizar progreso
          </button>
        </>
      )}
    </div>
  );
};
